import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { VisitPeriod } from './useVisits';

const API_BASE = process.env.REACT_APP_API_BASE || '';

export interface VisitDetail {
  id: string;
  parkName: string;
  visitDate: string;
  selectedAttractionCount: number;
  tripId: string | null;
  visitPeriod: VisitPeriod;
}

export function useVisit(visitId: string | null) {
  return useQuery({
    queryKey: ['visit', visitId],
    queryFn: async () => {
      if (!visitId) throw new Error('Missing visit ID');
      const response = await fetch(`${API_BASE}/api/visits/${visitId}`);
      if (!response.ok) throw new Error(`Server error: ${response.status}`);
      return response.json() as Promise<VisitDetail>;
    },
    enabled: !!visitId,
  });
}

export function useUpdateVisit() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ visitId, data }: { visitId: string; data: Record<string, unknown> }) => {
      const response = await fetch(`${API_BASE}/api/visits/${visitId}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });
      if (!response.ok) throw new Error('Failed to update visit');
      return response.json();
    },
    onSuccess: (_, { visitId }) => {
      queryClient.invalidateQueries({ queryKey: ['visit', visitId] });
      queryClient.invalidateQueries({ queryKey: ['visits'] });
    },
  });
}
